import React from "react";
import { EligibiltyForecastContainer } from "../../../containers";

const EligibiltyForecast = (props) => {
  return <EligibiltyForecastContainer {...props} />;
};

export default EligibiltyForecast;
